<template>
  <div class="date-input-form">
    <div class="heading" :style="headingStyle">
      <div class="text"><slot></slot></div>
      <div class="required" v-if="requiredFlg">必須</div>
    </div>
    <div class="body" :style="bodyStyle">
      <validation-provider
        class="validate"
        :rules="{ requiredRule: requiredFlg }"
      >
        <v-date-picker
          :value="displayDate"
          :min-date="displayMinDate"
          :max-date="displayMaxDate"
          @input="inputDate"
          data-test="v-date-picker"
          is-required
          ref="vDatePicker"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              class="v-date-picker"
              :value="inputValue"
              v-on="inputEvents"
              readonly
            />
          </template>
        </v-date-picker>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import '@/utils/validation_rules'
import moment from 'moment'
import { waitThenMouseOver } from '@/utils/vDatePicker'

export default {
  name: 'DateInputForm',
  components: { ValidationProvider },
  props: {
    headingStyle: { type: Object },
    bodyStyle: { type: Object },
    requiredFlg: { type: Boolean, default: false },
    date: { type: String, required: true },
    minDate: { type: String, default: '' },
    maxDate: { type: String, default: '' }
  },
  data() {
    return {
      timeoutIds: []
    }
  },
  computed: {
    displayDate() {
      return this.date === '' ? null : moment(this.date).toDate()
    },
    displayMinDate() {
      return this.minDate === '' ? null : moment(this.minDate).toDate()
    },
    displayMaxDate() {
      return this.maxDate === '' ? null : moment(this.maxDate).toDate()
    }
  },
  mounted() {
    document.addEventListener('toggle-popover', this.onTogglePopover)
  },
  beforeDestroy() {
    document.removeEventListener('toggle-popover', this.onTogglePopover)
    this.timeoutIds.forEach(timeoutId => clearTimeout(timeoutId))
  },
  methods: {
    async onTogglePopover() {
      const timeoutId = await waitThenMouseOver(
        this.$refs.vDatePicker,
        this.onClick
      )
      this.timeoutIds.push(timeoutId)
    },
    async onClick() {
      const timeoutId = await waitThenMouseOver(this.$refs.vDatePicker)
      this.timeoutIds.push(timeoutId)
    },
    inputDate(val) {
      if (val !== null) {
        this.$emit('input-date', moment(val).format('YYYYMMDD'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.date-input-form {
  display: flex;
  align-items: center;
  font-size: 15px;
  > .heading {
    display: flex;
    align-items: center;
    width: 40%;
    > .required {
      margin-left: 10px;
      font-size: 13px;
      color: #{$tomato};
    }
  }
  > .body {
    width: 60%;
    > .validate {
      ::v-deep {
        > span {
          .v-date-picker {
            box-sizing: border-box;
            font-size: 13px;
            text-align: right;
            padding-right: 12px;
            width: 140px;
            height: 33px;
            border-radius: 5px;
            border: solid 2px #{$light-grey};
            text-indent: 5px;
            cursor: pointer;
            background-image: url('../../../assets/images/calendar.png');
            background-size: 18px 18px;
            background-repeat: no-repeat;
            background-position: 5px center;
          }
        }
      }
    }
  }
}
</style>
